{
  "login.html": {
    "anchor": "start",
    "titleKey": "login"
  },
  "index.html": {
    "anchor": "start",
    "titleKey": "index"
  },
  "users.html": {
    "anchor": "members",
    "titleKey": "users"
  },
  "review.html": {
    "anchor": "review",
    "titleKey": "review"
  },
  "meetups.html": {
    "anchor": "sessions",
    "titleKey": "meetups"
  },
  "group.html": {
    "anchor": "groups",
    "titleKey": "group"
  },
  "restaurant.html": {
    "anchor": "restaurants",
    "titleKey": "restaurant"
  },
  "feedback.html": {
    "anchor": "feedback",
    "titleKey": "feedback"
  },
  "feedback-ai-analysis.html": {
    "anchor": "feedback",
    "titleKey": "feedback-ai-analysis"
  },
  "notification.html": {
    "anchor": "notifications",
    "titleKey": "notification"
  },
  "notificationedit.html": {
    "anchor": "notifications",
    "titleKey": "notificationedit"
  },
  "edm.html": {
    "anchor": "edm",
    "titleKey": "edm"
  },
  "edmedit.html": {
    "anchor": "edm",
    "titleKey": "edmedit"
  },
  "EDMGenerator.html": {
    "anchor": "edm",
    "titleKey": "EDMGenerator"
  },
  "promocode.html": {
    "anchor": "promos",
    "titleKey": "promocode"
  },
  "promocodeedit.html": {
    "anchor": "promos",
    "titleKey": "promocodeedit"
  },
  "billing.html": {
    "anchor": "billing",
    "titleKey": "billing"
  },
  "seasonpass.html": {
    "anchor": "billing",
    "titleKey": "seasonpass"
  },
  "countrycity.html": {
    "anchor": "cities",
    "titleKey": "countrycity"
  },
  "manager.html": {
    "anchor": "managers",
    "titleKey": "manager"
  },
  "analyze.html": {
    "anchor": "analysis",
    "titleKey": "analyze"
  },
  "deeplink.html": {
    "anchor": "deeplink",
    "titleKey": "deeplink"
  },
  "userDetails.html": {
    "anchor": "user-details",
    "titleKey": "userDetails"
  },
  "ai_gen.html": {
    "anchor": "ai",
    "titleKey": "ai_gen"
  },
  "modelinfo.html": {
    "anchor": "ai",
    "titleKey": "modelinfo"
  },
  "highriskinfo.html": {
    "anchor": "ai",
    "titleKey": "highriskinfo"
  },
  "high_risk_report.html": {
    "anchor": "ai",
    "titleKey": "high_risk_report"
  },
  "quicksetup.html": {
    "anchor": "secondary",
    "titleKey": "quicksetup"
  },
  "themetable.html": {
    "anchor": "secondary",
    "titleKey": "themetable"
  },
  "themetableedit.html": {
    "anchor": "secondary",
    "titleKey": "themetableedit"
  },
  "agent/setup.html": {
    "anchor": "agent-setup",
    "titleKey": "agent/setup"
  }
}
